import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import ArticleField from '../ArticleField';

interface PaywallProps {
    value: string,
    onChange: (str: string) => void,
}

const Paywall = (props: PaywallProps) => {
    return  <ArticleField label="Mode de fonctionnement du paywall">
            <Select fullWidth value={props.value} onChange={(e) => {
            props.onChange(e.target.value as string);
        }}>
            <MenuItem  value="normal">Normal</MenuItem>
            <MenuItem  value="forcepaywall">Forcer le paywall</MenuItem>
            <MenuItem  value="desactivatepaywall">Désactiver le paywall</MenuItem>
        </Select>
    </ArticleField>
}

export default Paywall;